export default __webpack_public_path__ + "static/media/green-ops.3e5dca02.svg";